<button class="btn btn-large  button-primary pull-right" (click)="downloadReport()" [disabled]="reportLoading">
  <i [ngClass]="{ 'fa-spin': reportLoading, 'fa-spinner': reportLoading, 'fa-cloud-download': !reportLoading }" class="fa"></i>
  Download Report
</button>
